import React from "react";
import { getTranslation } from "../../../../../utils/translation";
import { IncidentComment } from "../../../../../lib/ground-aws-graphql-core/models/Api/Incidents";
import { TableChangeParams } from "../../../../../components/Table/types";
import Table from "../../../../../components/Table";
import {
  DEFAULT_LIMIT,
  displayDayDDMMYYYY_HHMM,
} from "../../../../../utils/config";
import { GroundGraphqlContextStore } from "../../../../../lib/ground-aws-graphql-core";
import { BodyRow } from "../../../../../components/Table/Body";

type Props = {
  incidentComments?: IncidentComment[];
  total: number;
  onChange: (params: TableChangeParams) => void;
};

const IncidentCommentsTable = (props: Props): JSX.Element => {
  const { incidentComments, total, onChange } = props;

  const centerTimezone = GroundGraphqlContextStore.useStoreState(
    state => state.center.centerTimezone
  );

  const incidentCommentsTableHead = [
    "general.date",
    "general.comment",
    "general.issuer",
  ];

  const incidentCommentTableBody: BodyRow[] = incidentComments?.map(item => {
    const { comment: iComment, issuer, created_at: createdAt } = item;

    const incidentCommentsElements = [
      {
        element: displayDayDDMMYYYY_HHMM(createdAt, centerTimezone),
      },
      {
        element: getTranslation(JSON.stringify(iComment)),
      },
      {
        element: issuer || "",
      },
    ];

    return {
      id: item.id.toString(),
      rowElements: incidentCommentsElements,
    };
  });

  return (
    <Table
      head={incidentCommentsTableHead}
      body={incidentCommentTableBody}
      noDataText="page.list.incident.comments.empty"
      paginationTotal={total}
      paginationLimit={DEFAULT_LIMIT}
      onChange={onChange}
    />
  );
};

export default IncidentCommentsTable;
